import {Expose} from "class-transformer";
export default class Meta {
    @Expose({name: "current_page"})
    currentPage: number;

    @Expose({name: "next_page"})
    nextPage: number;

    @Expose({name: "prev_page"})
    prevPage: number;

    @Expose({name: "total_count"})
    totalCount: number;

    @Expose({name: "total_pages"})
    totalPages: number;

    cursor?: number;

    hasNext(){
        return this.currentPage < this.totalPages;
    }
}


// WEBPACK FOOTER //
// ./app/client/_data/models/Meta.ts